/**
 * Enumerations of the Make It project model, as string unions.
 *
 * The numeric values come from the Unity C# source (Assets/Scripts) and are
 * kept here only so the Unity → JSON mapper can translate them. The JSON
 * schema itself always uses the string names.
 */
export const SLIDE_TYPES = {
    0: "free",
    1: "connect",
    2: "drag",
    3: "memory",
    4: "quiz",
    5: "fillWithLetters",
    6: "tapIt",
    7: "order",
    8: "word",
    9: "phrase",
    10: "dragText",
    11: "traceable",
    12: "puzzle",
    13: "paint",
    14: "simbolDraw",
    15: "trueFalse",
    16: "math",
    17: "typeAnswer",
    18: "sort",
    19: "imageReveal",
    20: "missingLetter",
    21: "missingWord",
    22: "sequencesImg",
    23: "fractions",
    24: "scale",
    25: "mole",
    26: "crossword",
    50: "quizzesQuiz",
};
export const SLIDE_TYPE_VALUES = Object.values(SLIDE_TYPES);
export const PROJECT_TYPES = { 0: "demoGame", 1: "game", 2: "quiz", 3: "quizDemo" };
export const PROJECT_TYPE_VALUES = Object.values(PROJECT_TYPES);
export const POSITIVE_REINFORCEMENT = { 0: "none", 1: "simple", 2: "characters" };
export const POSITIVE_REINFORCEMENT_VALUES = Object.values(POSITIVE_REINFORCEMENT);
export const TIMER_TYPES = { 0: "none", 1: "clock", 2: "timer" };
export const TIMER_TYPE_VALUES = Object.values(TIMER_TYPES);
export const OWNERS = { 0: "none", 1: "me", 2: "others", 3: "classroom" };
export const OWNER_VALUES = Object.values(OWNERS);
export const MEDIA_SOURCES = { 0: "none", 1: "personalized", 2: "library", 3: "recorded" };
export const MEDIA_SOURCE_VALUES = Object.values(MEDIA_SOURCES);
/** Unity `TextAnchor`. */
export const TEXT_ALIGNS = {
    0: "upperLeft",
    1: "upperCenter",
    2: "upperRight",
    3: "middleLeft",
    4: "middleCenter",
    5: "middleRight",
    6: "lowerLeft",
    7: "lowerCenter",
    8: "lowerRight",
};
export const TEXT_ALIGN_VALUES = Object.values(TEXT_ALIGNS);
/** `TamanyText`: the numeric value is the Unity font size on the 2048×1536 reference canvas. */
export const TEXT_SIZES = { 50: "xxs", 70: "xs", 90: "s", 110: "m", 130: "l", 150: "xl", 180: "xxl", 230: "xxxl" };
export const TEXT_SIZE_VALUES = Object.values(TEXT_SIZES);
export const TEXT_SIZE_PX = { xxs: 50, xs: 70, s: 90, m: 110, l: 130, xl: 150, xxl: 180, xxxl: 230 };
/** `ElementType` of a FreeElement (what kind of free element it is). */
export const FREE_ELEMENT_TYPES = {
    0: "text",
    1: "image",
    2: "sound",
    3: "dragTo",
    4: "container",
    5: "connect",
    6: "memory",
    7: "answer",
    8: "question",
    9: "toFillWithLetters",
    10: "tap",
    11: "order",
    12: "word",
    13: "phrase",
    14: "video",
    15: "phraseFake",
    16: "dragText",
    17: "traceablePoint",
    18: "paint",
    19: "puzzle",
    20: "puzzlePiece",
    /** A drawing made with the editor's Drawing tool (DrawCanvasController): a PNG shown like an image. */
    21: "draw",
};
export const FREE_ELEMENT_TYPE_VALUES = Object.values(FREE_ELEMENT_TYPES);
/** `TemplateType` (visual theme). Values ≥ 50 are flat colours named by hex. */
export const TEMPLATES = {
    0: "none",
    1: "makeIt",
    2: "blocks",
    3: "blueSky",
    4: "buttermelt",
    5: "numbers",
    6: "vowels",
    7: "paper",
    8: "pastel",
    9: "polkaDot",
    10: "purpleLush",
    11: "rougeStar",
    12: "springLeaf",
    13: "wall",
    14: "carbon",
    15: "kilt",
    16: "comic",
    17: "waterColor",
    18: "concrete",
    19: "hexagon",
    20: "xmas",
    21: "circuit",
    22: "green",
    23: "whiteBoard",
    24: "notebook",
    25: "map",
    26: "oldPhoto",
    27: "stripes",
    50: "#b45255",
    51: "#fc5b60",
    52: "#fca465",
    53: "#fed46d",
    54: "#fefd73",
    55: "#ceec75",
    56: "#7fc277",
    57: "#5b9473",
    58: "#68c3bb",
    59: "#76fefe",
    60: "#5badef",
    61: "#8786d3",
    62: "#4d5f9f",
    63: "#925ca8",
    64: "#bb588d",
    65: "#fc63af",
    66: "#76665d",
};
export const TEMPLATE_VALUES = Object.values(TEMPLATES);
export const MATH_OPERATIONS = { 0: "sum", 1: "subtraction", 2: "multiplication", 3: "division" };
export const MATH_OPERATION_VALUES = Object.values(MATH_OPERATIONS);
export const MATH_TO_GUESS = { 0: "no", 1: "element1", 2: "operation", 3: "element2", 4: "equal", 5: "result" };
export const MATH_TO_GUESS_VALUES = Object.values(MATH_TO_GUESS);
export const SIMBOL_GROUPS = { 0: "latinLower", 1: "latinUpper", 2: "numbers" };
export const SIMBOL_GROUP_VALUES = Object.values(SIMBOL_GROUPS);
/** Unity `SystemLanguage` → ISO 639-1 code (`"unknown"` when unset). */
export const SYSTEM_LANGUAGES = {
    0: "af", 1: "ar", 2: "eu", 3: "be", 4: "bg", 5: "ca", 6: "zh", 7: "cs", 8: "da", 9: "nl", 10: "en",
    11: "et", 12: "fo", 13: "fi", 14: "fr", 15: "de", 16: "el", 17: "he", 18: "hu", 19: "is", 20: "id",
    21: "it", 22: "ja", 23: "ko", 24: "lv", 25: "lt", 26: "no", 27: "pl", 28: "pt", 29: "ro", 30: "ru",
    31: "sh", 32: "sk", 33: "sl", 34: "es", 35: "sv", 36: "th", 37: "tr", 38: "uk", 39: "vi",
    40: "zh-Hans", 41: "zh-Hant", 42: "unknown", 43: "hi",
};
//# sourceMappingURL=enums.js.map